import { useState } from 'react';
import { useMutation } from 'react-fetching-library';
import { Typography, makeStyles } from '@material-ui/core';
import { useParams } from 'react-router';
import ConfirmPasswordForm from 'components/Shared/ConfirmPasswordForm';
import AuthFormWrapper from 'components/Wrappers/AuthFormWrapper';
import { ALL_ROUTES } from 'config/routes';
import showServerError from 'helpers/showError';
import { useDispatch, useSelector } from 'react-redux';
import {
  enqueueSnackbar,
  SNACKBAR_VARIANTS,
  setHipaaCheckParams as setHipaaCheckParamsAction,
} from '../../redux_store';

const useStyles = makeStyles((theme) => ({
  text: {
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
}));

const AcceptInvitation = () => {
  const { en: { btn, errors, notifications, forms } } = useSelector((state) => state.i18n);
  const dispatch = useDispatch();
  const [backendErrors, setBackendErrors] = useState({});
  const classes = useStyles();
  const { token } = useParams();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const acceptInvitationAction = (values) => ({
    method: 'POST',
    endpoint: `/user-invitations/${token}`,
    body: values,
  });
  const { loading, mutate } = useMutation(acceptInvitationAction);

  const acceptInvitation = async (values, { setSubmitting }) => {
    setBackendErrors({});
    const { payload, error, status } = await mutate(values);
    if (error) {
      setIsFailed(true);
      setTimeout(() => {
        setIsFailed(false);
      }, 2000);
      setSubmitting(false);
      const options = payload && {
        correlationUUID: payload.correlationUUID,
      };

      switch (status) {
        case 422: {
          showServerError(dispatch, errors.validationError);
          setBackendErrors(payload.validationErrors);
          break;
        }
        case 500: {
          switch (payload.errorCode) {
            case 1: {
              showServerError(dispatch, errors.noLongerValid);
              break;
            }
            default: {
              showServerError(dispatch, '', options);
              break;
            }
          }
          break;
        }
        default: {
          showServerError(dispatch, '', options);
          break;
        }
      }
    } else if (payload) {
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
      }, 2000);
      dispatch(
        enqueueSnackbar({
          message: notifications.welcomeToQHS,
          options: {
            variant: SNACKBAR_VARIANTS.success,
          },
        }),
      );
      if (!payload.authMetadata) {
        showServerError(
          dispatch,
          errors.doNotHaveAccessToAnyAccounts,
        );
        return;
      }
      dispatch(
        setHipaaCheckParamsAction({
          newUser: payload.user,
          newMetadata: payload.authMetadata,
          newRoute: {
            path: ALL_ROUTES.root.path,
          },
        }),
      );
    }
  };

  return (
    <AuthFormWrapper>
      <Typography className={classes.text}>
        {forms.acceptInvitation}
      </Typography>
      <ConfirmPasswordForm
        backendErrors={backendErrors}
        onSubmit={acceptInvitation}
        loading={loading}
        isSuccess={isSuccess}
        isFailed={isFailed}
        cancelButtonRoute={ALL_ROUTES.login}
        submitText={btn.setPasswordLogIn}
      />
    </AuthFormWrapper>
  );
};

export default AcceptInvitation;
